<template>
  <div>
    <Author
        :profile-image-url="thread.author.profile_image_url_https"
        :location="thread.author.location"
        :description="thread.author.description"
        :followers-count="thread.author.followers_count"
        :name="thread.author.name"
        :screen-name="thread.author.screen_name"
    >
        <template #right-side>
					<button @click="$router.push({ path: `/author/${thread.author.id_str}` })" class="secondary-button" style="margin-left: 0px;">View Author</button>
					
          <button @click="like" v-if="!hasLike()" type="button" class="new-like-button" style="margin-right: 0px;">
						<span>{{likes.length}}</span>
						<i class="fas fa-caret-up new-like-button-icon"></i>
					</button>
					<button @click="dislike" v-if="hasLike()" type="button" class="new-like-button new-like-button-disabled" style="margin-right: 0px;">
						<span>{{likes.length}}</span>
						<i class="fas fa-caret-up new-like-button-icon"></i>
					</button>

        </template>
    </Author>

    <div class="page-container" style="min-height: 0px; max-width: 630px;">
			<div class="title-thread-container">
				<div class="title-thread">{{thread.title}}</div>
				<div style="font-size: 14px; opacity: 0.6;">{{thread.createdAt.toDate().toDateString()}}</div>
				<div class="divider-title-thread"></div>
			</div>
    </div>

    <ThreadTweet
        :index="1"
        :text="thread.tweet.text"
        url=""
    />

    <template v-if="showAllTweets">
        <ThreadTweet 
            v-for="(c, i) in thread.conversation.conversation"
            :key="`threadTweet-${i}`" 

            :index="i + 1"
            :text="c.text"
        />
    </template>

    <div class="page-container" style="min-height: 0px; max-width: 630px;">
        <div class="tags-container">
            <button v-if="showReadIt" class="primary-button" style="margin: 3px; margin-left: 0px;" @click="$router.push({ path: `/thread/${thread.id}` })">Read 🧵</button>
            <div v-for="(t, i) in thread.primaryTags" :key="`primary-tags-${i}`" class="tags-button">{{t}}</div>
            <div v-for="(t, i) in thread.secondaryTags" :key="`secondary-tags-${i}`" class="tags-button">{{t}}</div>
        </div>
    </div>

  </div>
</template>

<script>
import ThreadTweet from '@/components/ThreadTweet'
import Author from '@/components/Author'

import firebase from '@/firebase'

export default {
    props: [
        'thread',
        'showAllTweets',
        'showReadIt',
    ],

    data() {
      return {
        likes: [],
      }
    },

    components: {
        Author,
        ThreadTweet,
    },

    mounted() {
      this.m()
    },

    methods: {
      async m() {
        this.thread.ref.collection('likes').get()
          .then(snap => {
            const likes = []
            for(const doc of snap.docs){
              const like = doc.data()
              like.id = doc.id
              likes.push(like)
            }
            this.likes = likes
          })
          .catch(e => console.error(e))
      },

      like() {
        if(firebase.auth.currentUser == null){
          this.$store.state.showLoginModal = true
          return
        }

        const userId = firebase.auth.currentUser.uid
        this.likes.push({ id: userId })

        this.$store.commit('like', this.thread.id)
      },

      dislike() {
        if(firebase.auth.currentUser == null){
          this.$store.state.showLoginModal = true
          return
        }
        const userId = firebase.auth.currentUser.uid

        const i = this.likes.findIndex(x => x.id == userId)
        this.likes.splice(i, 1)

        this.$store.commit('dislike', this.thread.id)
      },

      hasLike() {
        if(firebase.auth.currentUser == null){
          return false
        }
        const userId = firebase.auth.currentUser.uid
        const f = this.likes.find(l => l.id === userId)
        return f != null
      },
    },
}
</script>

<style>
.page-container{
  max-width: 1100px;
  min-height: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .page-container{
    padding: 0 0.5rem;
  }
}
</style>